/*
 * @Author: lbh
 * @Date: 2025-10-23 14:41:39
 * @LastEditors: lbh
 * @LastEditTime: 2025-10-23 15:26:20
 * @Description: file content
 */
export default {
  whatsapp: {
    立即参加: "立即参加",
    还差X: "还差 ${X}",
    已满足参加中: "已满足参与中",
    消费满X赠送价值Y现金券: "消费满 ${X} 赠送价值 ${Y} 现金券",
    消费满X赠送Y张ZOFF折扣券: "消费满 ${X} 赠送 {Y}张 {Z}%OFF 折扣券",
    消费满X获得Y张优惠券: "消费满 ${X} 获得 {Y} 张优惠券",
    立即领取: "立即领取",
    已经领取: "已经领取",
    参与中: "参与中",
  },
};
